export default __webpack_public_path__ + "static/media/avatars(5).60b88cc8.png";